<template>
    <div class="pedidos-section">
        <div class="pedidos-content">
            <h2 class="pedidos-title fuente-posm">
                Todos tus Pedidos en Una Sola Plataforma
            </h2>
            <p class="pedidos-text fuente-nova">
                Los pedidos de Uber Eats y Rappi se reciben automáticamente.
                <br><br>
                Se imprimen o ingresan directo a tu POS sin intervención manual.
            </p>
        </div>
        <div class="pedidos-image">
            <img :src="a72" alt="Pedidos en una plataforma">
        </div>
    </div>
</template>

<script>
export default {
    name: 'PedidosPlataformaNew',
    data() {
        return {
            a72: require('@/assets/images/a72.webp')
        }
    }
}
</script>

<style lang="css" scoped>
.pedidos-section {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 40px 60px;
    box-sizing: border-box;
    scroll-snap-align: start;
    gap: 40px;
}

.pedidos-image {
    flex: 0 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    order: 2;
}

.pedidos-image img {
    width: 400px;
    height: auto;
}

.pedidos-content {
    flex: 1;
    max-width: 700px;
    order: 1;
}

.pedidos-title {
    color: var(--color-2);
    font-size: 68px;
    line-height: 1.1;
    margin: 0 0 20px 0;
}

.pedidos-text {
    color: var(--color-3);
    font-size: 29px;
    line-height: 1.3;
    margin: 0;
    padding-left: 10px;
}

/* Tablet */
@media (max-width: 992px) and (min-width: 769px) {
    .pedidos-title {
        font-size: 60px;
    }

    .pedidos-text {
        font-size: 27px;
    }

    .pedidos-image img {
        width: 320px;
    }
}

/* Mobile */
@media (max-width: 768px) {
    .pedidos-section {
        flex-direction: column;
        justify-content: flex-start;
        height: 100vh;
        padding: 100px 20px 40px 20px;
        gap: 20px;
    }

    .pedidos-content {
        order: 1;
        max-width: 100%;
        flex: none;
    }

    .pedidos-image {
        order: 2;
        width: 100%;
        flex: 1;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        padding-top: 20px;
    }

    .pedidos-image img {
        width: 80%;
        max-width: 320px;
    }

    .pedidos-title {
        font-size: 24px;
        line-height: 1.2;
        margin: 0 0 10px 0;
    }

    .pedidos-text {
        font-size: 16px;
        padding-left: 10px;
        margin: 0;
    }
}
</style>
